export const EXTERNAL_UPLOAD_REQUEST = "external/UPLOAD_REQUEST";
export type T_EXTERNAL_UPLOAD_REQUEST = typeof EXTERNAL_UPLOAD_REQUEST;
